import { useMutation, useQueryClient } from "@tanstack/react-query";
import { hubMutations } from "@surgia/api/src/queryStore/hub";
import { toast } from "sonner";

export const useSubmitPurchaseRequest = (draftQueryParams?: {
  branchId: string;
  componentId: string;
  tenantId: string;
}) => {
  const queryClient = useQueryClient();
  
  return useMutation({
    ...hubMutations.purchaseRequest.mutations.submit(),
    onSuccess: async () => {
      toast.success("Purchase request submitted successfully");
      if (draftQueryParams) {
        const queryKey = ['purchaseRequest', 'draft', {
          branchId:draftQueryParams?.branchId,
          componentId:draftQueryParams?.componentId,
          tenantId: Number(draftQueryParams.tenantId)
        }];
        
        queryClient.invalidateQueries({
          queryKey: queryKey
        });
      }
      
      queryClient.invalidateQueries({
        predicate: (query) => {
          const keyString = JSON.stringify(query.queryKey);
          return (
            (keyString.includes("purchaseRequest") &&
              keyString.includes("draft")) ||
            (keyString.includes("purchaseRequest") &&
              keyString.includes("listings")) ||
              keyString?.includes("tenant-products")
          );
        },
      });
    },
    onError: (error) => {
      console.error('Failed to submit purchase request:', error);
      toast.error("Failed to submit purchase request. Please try again.");
    }
  });
}; 